import { Box, Chip, Popover, TextField, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";

const joinOptions = ["Immediate", "15", "30", "60"];

const SearchWithFilter = ({
  filters,
  setFilters,
  searchText,
  setSearchText,
  activeFilter,
  setActiveFilter,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  // const [filters, setFilters] = useState({
  //   location: [],
  //   skill: [],
  //   joinWithin: [],
  // });

  const locations = ["Ch. SambhajiNagar", "Pune", "Mumbai"];
  const skills = ["Hair Cut", "Hair Color", "Styling"];
  const joinOptions = ["Immediate", "15", "30", "60"];

  const open = Boolean(anchorEl);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const removeChip = (type, value) => {
    setFilters((prev) => ({
      ...prev,
      [type]: prev[type].filter((item) => item !== value),
    }));
  };

  return (
    <>
      {/* SEARCH BAR */}
      <TextField
        fullWidth
        size="small"
        value={searchText}
        onClick={handleOpen}
        onChange={(e) => {
          if (!activeFilter) return; // prevent typing before filter selection
          setSearchText(e.target.value);
        }}
        label={
          activeFilter === "location"
            ? "Search Location"
            : activeFilter === "skill"
              ? "Search Skill"
              : activeFilter === "joinWithin"
                ? "Join Within (15 / 30 / 60)"
                : "Select filter"
        }
        sx={{
          backgroundColor: "white",
          borderRadius: 1,
          "& fieldset": { border: "none" },
        }}
        InputProps={{
          readOnly: !activeFilter, // 👈 important
          endAdornment: (
            <SearchIcon
              sx={{
                cursor: activeFilter ? "pointer" : "not-allowed",
                color: (theme) => theme.palette.primary.main,
              }}
              onClick={() => {
                if (!activeFilter || !searchText.trim()) return;

                setFilters((prev) => ({
                  ...prev,
                  [activeFilter]: prev[activeFilter].includes(searchText)
                    ? prev[activeFilter]
                    : [...prev[activeFilter], searchText],
                }));

                setSearchText("");
                handleClose();
              }}
            />
          ),
        }}
      />

      {/* FILTER POPOVER */}
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            width: 300,
            p: 2,
            borderRadius: 2,
          },
        }}
      >
    
        <Box mb={2}>
          <Typography
            sx={{ fontWeight: 600, mb: 1, cursor: "pointer" }}
            onClick={() => {
              setActiveFilter("location");
              setSearchText("");
            }}
          >
            Preferred Location
          </Typography>

          <Box display="flex" gap={1} flexWrap="wrap">
            {filters?.location.map((item) => (
              <Chip
                key={item}
                label={item}
                onDelete={() => removeChip("location", item)}
                deleteIcon={<CloseIcon />}
                sx={{
                  backgroundColor: "#CECEFF",
                  color: "#01008B",
                  fontWeight: 500,
                  boxShadow: "0px 2px 6px rgba(0,0,0,0.12)",
                }}
              />
            ))}
          </Box>
        </Box>

       

        <Box mb={2}>
          <Typography
            sx={{ fontWeight: 600, mb: 1, cursor: "pointer" }}
            onClick={() => {
              setActiveFilter("skill");
              setSearchText("");
            }}
          >
            Skill
          </Typography>

          <Box display="flex" gap={1} flexWrap="wrap">
            {filters?.skill.map((item) => (
              <Chip
                key={item}
                label={item}
                onDelete={() => removeChip("skill", item)}
                deleteIcon={<CloseIcon />}
                sx={{
                  backgroundColor: "#CECEFF",
                  color: "#01008B",
                  fontWeight: 500,
                  boxShadow: "0px 2px 6px rgba(0,0,0,0.12)",
                }}
              />
            ))}
          </Box>
        </Box>

        <Typography
          sx={{ fontWeight: 600, mb: 1, cursor: "pointer" }}
          onClick={() => {
            setActiveFilter("joinWithin");
            setSearchText("");
          }}
        >
          Join within
        </Typography>

        <Box display="flex" gap={1} flexWrap="wrap">
          {joinOptions?.map((item) => {
            const isSelected = filters?.joinWithin.includes(item);
            const toggleItem = () => {
              setFilters((prev) => ({
                ...prev,
                joinWithin: isSelected
                  ? prev.joinWithin.filter((i) => i !== item)
                  : [...prev.joinWithin, item],
              }));
            };

            return (
              <Chip
                key={item}
                label={item}
                onDelete={isSelected ? toggleItem : undefined}
                deleteIcon={isSelected ? <CloseIcon /> : undefined}
                onClick={toggleItem}
                sx={{
                  backgroundColor: isSelected ? "#CECEFF" : "#fff",
                  color: "#01008B",
                  fontWeight: 500,
                  cursor: "pointer",
                  boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.12)",

                  "&:hover": {
                    backgroundColor: isSelected ? "#CECEFF" : "#CECEFF",
                  },
                }}
              />
            );
          })}
        </Box>
      </Popover>
    </>
  );
};

export default SearchWithFilter;

const FilterSection = ({ title, items, selected, onToggle }) => (
  <Box mb={2}>
    <Typography sx={{ fontWeight: 600, mb: 1 }}>{title}</Typography>

    <Box display="flex" gap={1} flexWrap="wrap">
      {items.map((item) => {
        const isSelected = selected.includes(item);

        return (
          <Chip
            key={item}
            label={item}
            onClick={() => onToggle(item)}
            onDelete={isSelected ? () => onToggle(item) : undefined}
            deleteIcon={isSelected ? <CloseIcon /> : undefined}
            sx={{
              boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.12)",

              backgroundColor: isSelected ? "#CECEFF" : "#ffff",
              color: "#01008B",
              fontWeight: 500,
              cursor: "pointer",
              "&:hover": {
                backgroundColor: isSelected ? "#CECEFF" : "#CECEFF",
              },
            }}
          />
        );
      })}
    </Box>
  </Box>
);
